module.exports = __webpack_public_path__ + "img/blue_164.ff83d1ef.png";